module.exports = __webpack_public_path__ + "images/emoji/ballot_box_with_check.c8e1060ada0347650d9d.png";